import React from 'react';

// Generic money-rail card shell: title, status chip, one action, click to
// expand in place. Shared by the Estimate/Labor/Parts/Invoice/Comms cards.
export default function MoneyCard({
  title, chipLabel, chipColor, chipBg,
  actionLabel, onAction, expanded, onToggle, children,
}) {
  return (
    <div className={`ro-mcard${expanded ? ' ro-mcard--expanded' : ''}`}>
      <button type="button" className="ro-mcard-head" onClick={onToggle}>
        <span className="ro-mcard-title">{title}</span>
        {chipLabel && (
          <span className="ro-mcard-chip" style={{ color: chipColor, background: chipBg }}>
            {chipLabel}
          </span>
        )}
        <span className="ro-mcard-chevron">{expanded ? '▾' : '▸'}</span>
      </button>

      {!expanded && actionLabel && (
        <div className="ro-mcard-action-row">
          <button type="button" className="ro-mcard-action"
            onClick={(e) => { e.stopPropagation(); onAction(); }}>
            {actionLabel}
          </button>
        </div>
      )}

      {expanded && <div className="ro-mcard-body">{children}</div>}
    </div>
  );
}
